import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import * as S from "./styled";
//Hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Components
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
import AddiotionInputs from "../AdditionInputs";
//icons
import { WarningCircle } from "@phosphor-icons/react";
//Inteface
import { ICreate } from "Interfaces/ICreate";
import { IMethPay } from "Interfaces/IMethodPaym";
import { IFormPayment } from "Interfaces/IFormPayment";
import { IPromotion, Inputs } from "Interfaces/IPromotion";
import { IUser } from "Interfaces/IUser";
import axiosInstance from "services/axiosInstance";
export default function UpdatePromotion({
  isOpenModal: isOpenModalData,
  setModalClose,
  selectedUrlId,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    control,
    reset,
    setValue,
    getValues,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const [paymentMethods, setPaymentMethods] = useState({
    cash: [],
    credit: { id: null, payment_method: '' },
    paymentCredit: { id: 0, payment_method: '' }
  });
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [dataUpdate, setDataUpdate] = useState<IPromotion | null>(null);
  const [countInstallments, setCountInstallments] = useState(1);
  const [users, setUsers] = useState<IUser[]>([]);
  const [visible, setVisible] = useState(false);
  const [messager, setMessager] = useState('Esta promoção será visível para todos os vendedores da loja e usuários com cargos superiores.');

  const typeUsers = (typeAdm: number, typeManag: number): string => {
    if (typeAdm === 1) return 'Administrador';
    if (typeAdm === 1 && typeManag === 1) return 'Administrador|Gerente';
    if (typeManag === 1) return 'Gerente';
    return 'Vendedor';
  };

  //Função para mostrar campo de VENDEDOR ESPECÍFICO
  const handleVisible = (auth: string) => {
    if (auth.toLocaleLowerCase() === 'loja') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }

  //função para mostrar mensagem de atenção
  const handleVisibleMessager = (value: number) => {
    if (!value) {
      setMessager('Esta promoção será visível para todos os vendedores da loja e usuários com cargos superiores.');
    } else {
      const user = users.filter((val) => val.id === value);
      console.log('users: ', user);
      setMessager(`Esta promoção será visível apenas para ${(user[0].first_name).toLocaleUpperCase() || '-'}. Outros vendedores da loja e usuários com cargos superiores não poderão ver esta promoção.`);
    }
  }

  const typeProduct = (type: string) => {
    switch (type) {
      case 'App\\Models\\Lens':
        return 'lens';
      case 'App\\Models\\Frame':
        return 'frame';
      case 'App\\Models\\Accessory':
        return 'accessory';
      case 'App\\Models\\Service':
        return 'service';
    }
  }

  const fetchData = async () => {
    startLoading();
    try {
      const [responsePay, responseUser, responsePromo] = await Promise.all([
        axiosInstance.get("/payment-method"),
        axiosInstance.get("/user"),
        axiosInstance.get(`promotion/${selectedUrlId}`),
      ])
      const responsePayment = responsePay.data;
      const responseDataUser = responseUser.data.data;
      const dataItems = responsePromo.data;
      setDataUpdate(dataItems);

      console.log('Promoção update: ', dataItems);

      // Classificar métodos de pagamento
      const cash = responsePayment
        .filter((item: any) =>
          ['Dinheiro', 'Pix', 'Cartão de Débito'].includes(item.payment_method)
        ).map((payment: any) => ({
          ...payment,
          payment_method: payment.payment_method.replace('Cartão de Débito', 'Débito')
        }));

      const credit = responsePayment.find((item: any) =>
        item.payment_method === 'Cartão de Crédito'
      ) || null;

      const paymentCredit = responsePayment.find((item: any) =>
        item.payment_method === 'Crediário da Loja'
      ) || null;

      // adicionar os valores em cada campo
      for (const key in dataItems) {
        setValue(key as keyof Inputs, dataItems[key]);
        if (dataItems.auth === 'Loja') {
          setVisible(true);
        }
        if (dataItems.cash_promotions && Array.isArray(dataItems.cash_promotions)) {
          dataItems.cash_promotions.forEach((cashPromo: any, index: number) => {
            // Setando o valor de desconto para cada forma de pagamento
            setValue(`cashPromotions.${index}.discount`, cashPromo.discount);
            setValue(`cashPromotions.${index}.payment_method_id`, cashPromo.payment_method_id);
          });
        } if (dataItems.credit_promotions && Array.isArray(dataItems.credit_promotions)) {
          setCountInstallments(dataItems.credit_promotions);
          // setCountInstallments(dataItems.credit_promotions.length || 1);
          dataItems.credit_promotions.forEach((creditPromotions: any, index: number) => {
            // Setando o valor de desconto para cada forma de pagamento
            setValue(`creditPromotions.${index}.discount`, creditPromotions.discount);
            setValue(`creditPromotions.${index}.payment_method_id`, creditPromotions.payment_method_id);
          });
        } if (dataItems.payment_credit_promotion && Array.isArray(dataItems.payment_credit_promotion)) {
          dataItems.payment_credit_promotion.forEach((paymentCreditPromotions: any, index: number) => {
            // Setando o valor de desconto para cada forma de pagamento
            setValue(`paymentCreditPromotions.${index}.discount`,paymentCreditPromotions.discount);
            setValue(`paymentCreditPromotions.${index}.payment_method_id`,paymentCreditPromotions.payment_method_id);
          });
        }
      }
      // setDataUpdate(dataItems);
      // for (const key in dataItems) {
      //   if (
      //     key === 'title' ||
      //     key === 'status' ||
      //     key === 'auth' ||
      //     key === 'start' ||
      //     key === 'end' ||
      //     key === 'store_credit_discount'
      //   ) {
      //     setValue(key as keyof Inputs, dataItems[key]);
      //   } if (dataItems.cash_promotions && Array.isArray(dataItems.cash_promotions)) {
      //     dataItems.cash_promotions.forEach((cashPromo, index) => {
      //       // Setando o valor de desconto para cada forma de pagamento
      //       setValue(`cashPromotions.${index}.discount`, cashPromo.discount);
      //       setValue(`cashPromotions.${index}.payment_method_id`, cashPromo.form_payment.id);
      //     });
      //   } if (dataItems.credit_promotions && Array.isArray(dataItems.credit_promotions)) {
      //     dataItems.credit_promotions.forEach((credit, index) => {
      //       // Setando o valor de desconto para cada promoção de crédito
      //       setValue(`creditPromotions.${index}.discount`, credit.discount);
      //       setValue(`creditPromotions.${index}.installment`, credit.installment);
      //     })
      //   } if (dataItems.payment_credit_promotion && Array.isArray(dataItems.payment_credit_promotion)) {
      //     dataItems.payment_credit_promotion.forEach((payment_credit_promotion, index) => {
      //       setValue(`paymentCreditPromotions.${index}.discount`, payment_credit_promotion.payment_credit_promotion || 0);
      //     })
      //   }
      // }

      setPaymentMethods({
        cash,
        credit,
        paymentCredit
      });
      setUsers(responseDataUser);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalData && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalData, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const promotionItems = dataUpdate?.promotion_items.map((val) => {
        return {
          type: typeProduct(dataUpdate?.promotion_items[0].promotionable_type),
          id: val.promotionable_id
        }
      })

      const payload = {
        ...data,
        title: data.title.toLocaleUpperCase(),
        promotionItems
      }

      const response = await apiRequest(
        `promotion/${selectedUrlId}`,
        "PATCH",
        payload
      );

      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
  }

  if (isOpenModalData) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Promoção"
        subTitle="Preencha os dados da promoção do produto."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"
        nameIconMinimize={'Atualizar Promoção'}
      >
        {isLoading ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Container>
            <S.FormInput>
              <S.Label>
                Nome da Promoção
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da Promoção"
                type="text"
                {...register("title", { required: true })}
              />
              {errors.title && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Nível de Autorização
                  <span>*</span>
                </S.Label>
                <S.Select
                  {...register("auth", { required: true })}
                  onChange={(e) => handleVisible(e.target.value)}
                >
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="Administrador">
                    Administrador
                  </option>
                  <option value="Gerente">
                    Gerente
                  </option>
                  <option value="Loja">
                    Loja
                  </option>
                </S.Select>
                {errors.auth && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              {
                visible &&
                <S.FormInput>
                  <S.Label>
                    Vendedor Específico
                  </S.Label>
                  <S.Select
                    {...register("user_id")}
                    onChange={(e) => handleVisibleMessager(Number(e.target.value))}
                  >
                    <option value="" selected>
                      Todos os Vendedores
                    </option>
                    {
                      users.map((value) => (
                        <option key={value.id} value={value.id}>
                          {`${value.first_name || '-'} (${typeUsers(value.is_admin, value.is_manager)})`}
                        </option>
                      ))
                    }
                  </S.Select>
                </S.FormInput>
              }
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Período Inicial
                  <span>*</span>
                </S.Label>
                <S.Input
                  type="date"
                  {...register("start", { required: true })}
                />
                {errors.start && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Período Final
                  <span>*</span>
                </S.Label>
                <S.Input
                  type="date"
                  {...register("end", { required: true })}
                />
                {errors.end && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            {
              visible &&
              <S.ContentInfor>
                <S.Text className="title">
                  <WarningCircle size={12} /> Visibilidade da Promoção
                </S.Text>

                <S.Text className="subtitle">
                  {messager}
                </S.Text>
              </S.ContentInfor>
            }

            <S.FeaturedSection>
              <S.Title>
                Desconto À vista (%)
                <span>*</span>
              </S.Title>
              {paymentMethods.cash.map((val: IMethPay, index: number) => (
                <S.FormInput key={val.id}>
                  <S.ContentInput >
                    <S.LabelGray>{val.payment_method || '-'}</S.LabelGray>
                    <Controller
                      name={`cashPromotions.${index}.discount`}
                      rules={{ required: "Campo Obrigatório" }}
                      control={control}
                      render={({ field: { onChange, value, ref } }) => (
                        <NumericFormat
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          fixedDecimalScale={true}
                          placeholder="0,00 %"
                          suffix=" %"
                          value={value}
                          onValueChange={(values) => {
                            const discountValue = values.floatValue ?? 0;
                            setValue(`cashPromotions.${index}.payment_method_id`, val.id);
                            onChange(discountValue);
                          }}
                          getInputRef={ref}
                        />
                      )}
                    />
                  </S.ContentInput>
                  {errors.cashPromotions?.[index]?.discount && (
                    <S.InforErro>Campo Obrigatório</S.InforErro>
                  )}
                </S.FormInput>

              ))}
            </S.FeaturedSection>

            <AddiotionInputs
              payment_method_id={paymentMethods.credit?.id || null}
              getValues={getValues}
              register={register}
              errors={errors}
              reset={reset}
              control={control}
              setValue={setValue}
              resetField={resetField} 
              creditPromotions={dataUpdate?.credit_promotions}
              />

            <S.FormInput>
              <S.Label>
                Desconto no Crediário
                <span>*</span>
              </S.Label>
              <Controller
                name="paymentCreditPromotions"
                rules={{ required: "Campo Obrigatório" }}
                control={control}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="0,00 %"
                    suffix=" %"
                    value={value?.[0]?.discount || ''}
                    onValueChange={(values) => {
                      const discountValue = values.floatValue ?? 0;

                      const newValue = [
                        {
                          discount: discountValue,
                          payment_method_id: paymentMethods.paymentCredit?.id || null
                        }
                      ];

                      onChange(newValue); // Atualiza com o objeto esperado
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.paymentCreditPromotions && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
